module.exports = __webpack_public_path__ + "static/assets/8cb246f7af682c47ae1cfc6c5cb3aa68.png";